export const DeskConstants = {
    READ: 'read',
    WRITE: 'write',
    DESK: 'desk',
};
